import { render, staticRenderFns } from "./LtkCollectionSlidegroup.vue?vue&type=template&id=d3484fac&scoped=true"
import script from "./LtkCollectionSlidegroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./LtkCollectionSlidegroup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LtkCollectionSlidegroup.vue?vue&type=style&index=0&id=d3484fac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3484fac",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CreatorShopCollectionLtkCollectionTile: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/src/components/creator-shop/collection/LtkCollectionTile.vue').default,CSkeletonLoader: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSkeletonLoader/CSkeletonLoader.vue').default,CSlideItem: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CSlideGroup/CSlideItem.vue').default,CLtkSlideGroup: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkSlideGroup/CLtkSlideGroup.vue').default})
